import * as React from "react";

const CategoriesIcon = () => {
    return (
        <svg
            id="Group_2484"
            data-name="Group 2484"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="131.857"
            height="75"
            viewBox="0 0 131.857 91.311"
        >
            <defs>
                <clipPath id="clip-path">
                    <rect
                        id="Rectangle_1114"
                        data-name="Rectangle 1114"
                        width="131.857"
                        height="91.311"
                        fill="#fff"
                        stroke="#fff"
                        strokeWidth="1"
                    />
                </clipPath>
            </defs>
            <g id="Group_2426" data-name="Group 2426" transform="translate(0)" clipPath="url(#clip-path)">
                <path
                    id="Path_4397"
                    data-name="Path 4397"
                    d="M254.57,2.809c0-.052,0-.1-.008-.155s-.016-.116-.025-.173c-.006-.037-.01-.075-.017-.112-.011-.058-.027-.114-.041-.17-.01-.037-.017-.074-.028-.11-.016-.053-.035-.1-.055-.156s-.027-.078-.042-.116-.043-.093-.065-.14-.037-.082-.059-.121-.051-.088-.078-.132-.045-.077-.07-.115-.073-.1-.112-.152c-.02-.026-.038-.053-.059-.078A2.964,2.964,0,0,0,253.5.665c-.031-.025-.063-.047-.094-.071s-.088-.068-.134-.1-.1-.062-.152-.092c-.03-.018-.06-.037-.091-.054-.059-.032-.121-.06-.182-.088-.025-.011-.049-.024-.075-.035-.068-.029-.137-.052-.206-.075L252.5.13c-.08-.025-.162-.045-.244-.063l-.033-.008A2.964,2.964,0,0,0,251.6,0H183.881a2.937,2.937,0,0,0-2.08.863L164.135,18.53a2.946,2.946,0,0,0-.205.226c-.021.025-.039.052-.058.078-.038.05-.077.1-.112.152s-.047.077-.07.115-.054.087-.078.132-.039.081-.059.121-.045.092-.065.14-.029.077-.043.116-.039.1-.055.156c-.011.036-.019.073-.028.11-.015.057-.03.113-.042.17-.007.037-.011.075-.017.112-.009.057-.019.114-.025.173s-.005.1-.008.152-.007.089-.007.135V37.483a2.941,2.941,0,1,0,5.883,0V23.558h61.871v61.87H169.148V77.181a2.941,2.941,0,0,0-5.883,0V88.369a2.942,2.942,0,0,0,2.941,2.941H233.96c.1,0,.194-.005.29-.015.042,0,.082-.012.123-.018s.108-.014.162-.025.091-.022.136-.033.1-.023.144-.037.087-.03.13-.045.1-.033.142-.052.08-.037.12-.056.094-.043.14-.068.079-.046.118-.07.086-.05.127-.077.1-.072.148-.109c.027-.021.055-.039.081-.061q.118-.1.225-.2l17.668-17.666a2.939,2.939,0,0,0,.861-2.078V2.941c0-.044,0-.087-.007-.131M232.743,17.676H207.182L218.975,5.882h25.561ZM185.1,5.882h25.558L198.865,17.676H173.306ZM236.9,81.27V21.834l11.792-11.793V69.477Z"
                    transform="translate(-122.719 0.001)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="1"
                />
                <path
                    id="Path_4398"
                    data-name="Path 4398"
                    d="M284.706,136.369a2.941,2.941,0,0,0,0-5.883H267.031a2.941,2.941,0,1,0,0,5.883Z"
                    transform="translate(-198.505 -98.08)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="1"
                />
                <path
                    id="Path_4399"
                    data-name="Path 4399"
                    d="M51.208,194.513H2.941a2.941,2.941,0,0,1,0-5.883H51.208a2.941,2.941,0,0,1,0,5.883"
                    transform="translate(0 -141.785)"
                    stroke="#000"
                    strokeWidth="1"
                />
                <path
                    id="Path_4400"
                    data-name="Path 4400"
                    d="M120.945,255.28H72.678a2.941,2.941,0,0,1,0-5.883h48.267a2.941,2.941,0,0,1,0,5.883"
                    transform="translate(-52.418 -187.46)"
                    stroke="#000"
                    strokeWidth="1"
                />
            </g>
        </svg>
    );
};

export default React.memo(CategoriesIcon);
